var Utils = require("common/Utils");

function AttributesModel() {
    var self = this;
    var attributes;

    var getUrl;
    var postUrl;
    var useNamespaces = true;

    function initialiseServerPaths() {
        if (Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "7.1.0")) {
            getUrl = "/sslvpn_api/attributes";
            postUrl = "/sslvpn_api/attributes";
            useNamespaces = true;
        } else {
            getUrl = "/sslvpn_api/userAttributes/setting";
            postUrl = "/sslvpn_api/userAttributes";
            useNamespaces = false;
        }
    }

    function confirmInitialisedPaths() {
        if (!getUrl || !postUrl) {
            initialiseServerPaths();
        }
    }

    $(document).on("connectionsuccessful", initialiseServerPaths);
    $(document).on("initialiseServerPaths", initialiseServerPaths);

    this.getAttribute = function(category) {
        var attribute;
        confirmInitialisedPaths();

        if (useNamespaces) {
            attribute = attributes[category.namespace][category.title];
        } else {
            attribute = attributes[category];
        }
        return attribute;
    };

    this.getAttributes = function(category) {
        if (attributes) {
            return new $.Deferred().resolve(this.getAttribute(category)).promise();
        }

        return self.loadAttributes().then(function() {
            return self.getAttribute(category);
        });
    };

    this.buildCategories = function() {
        var categories = [];
        confirmInitialisedPaths();

        if (useNamespaces) {
            for (var namespace in attributes) {
                if (attributes.hasOwnProperty(namespace)) {
                    var cats = attributes[namespace];

                    for (var title in cats) {
                        if (cats.hasOwnProperty(title)) {
                            categories.push({namespace : namespace, title : title});
                        }
                    }
                }
            }
        } else {
            categories = Object.keys(attributes);
        }
        return categories;
    };

    this.getCategories = function() {
        if (attributes) {
            return new $.Deferred().resolve(this.buildCategories()).promise();
        }

        return self.loadAttributes().then(function() {
            return self.buildCategories();
        });
    };

    this.loadAttributes = function(refreshResources) {
        confirmInitialisedPaths();

        // Get the current values for the user attributes
        return $.ajax({
            url : getUrl,
            type : "GET",
            cache : false
        }).done(function(data) {
            console.debug("retrieved the user attribute values");
            attributes = data;
            $.event.trigger("attributesloaded", [data]);

            if (refreshResources) {
                CudaLaunch.models.resources.refresh();
            }
        }).fail(function() {
            console.error("unable to retrieve the user attribute values from the server");
        });
    };

    this.updateAttributes = function(submitData) {
        confirmInitialisedPaths();

        var params = {changes : JSON.stringify(submitData)};
        params["_method"] = "PUT";

        return $.post(postUrl, params)
            .done(function() {
                self.loadAttributes(true);
            });
    };

    this.reset = function() {
        attributes = {};
    };
}

module.exports = AttributesModel;